import axios from "axios";
import React from 'react';
import config from '../../config';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const ClientOnboarding = () => {
    //const companyId = useSelector((state) => state.user.companyId);
    const [kycWorkflowCompleted, setKycWorkflowCompleted] = useState(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const name = useSelector((state) => state.user.name);
    const navigate = useNavigate();
    const [err, setErr] = useState("")
    const [aadharNumber, setAadharNumber] = useState('');
    const [isAadharValid, setIsAadharValid] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [referenceId, setReferenceId] = useState('');
    const [clientName, setClientName] = useState('');
    const [otpEnabled, setOtpEnabled] = useState(false);
    const [isOtpValid, setIsOtpValid] = useState(false);
    const [inputs, setInputs] = useState({
        aadharNumber: 0,
        ClientCode: params.get("clientCode") || "",
        ProductCode: params.get("productCode") || "",
        ProductType: params.get("productType") || "LUMPSUM",
        PaymentMode: params.get("paymentMode") || "SM"
    })
    const [inputsOtp, setInputsOtp] = useState({
        otp: 0,
        transactionId: 0,
        referenceId: 0,
        clientName: ""
    });
    const [iframeUrl, setIframeUrl] = useState(false);
    const [iFrameKyc, setIFrameKyc] = useState(false);
    const [kycUrl, setKycUrl] = useState('');
    const [docketId, setDocketId] = useState('');
    const [signerId, setSignerId] = useState('');
    const [documentId, setDocumentId] = useState('');
    const [eSignStatus, setESignStatus] = useState(false);
    const [widgetInvitationLink, setWidgetInvitationLink] = useState('')

    useEffect(() => {
        const payload = {
            aadharNumber: "",
            ClientCode: params.get("clientCode") || "",
            ProductCode: params.get("productCode") || "",
            ProductType: "",
            PaymentMode: "",
            Name: "",
            Address1: "",
            Address2: "",
            Address3: "",
            City: "",
            CKYC: "",
            ClientIPAddress: "",
            DeviceType: "",
            FatherName: "",
            gender: "",
            isClientTypeIndividual: "",
            IsKYCAgree: "",
            IsNRI: "",
            MobileNumber: "",
            Pan: "",
            PinCode: 0,
            TPRefId: params.get("token") || "",
            DOB: "",
            EmailAddress: ""
        };

        // Example API call on page load
        const fetchInitialData = async () => {
            try {
                const url = `${config.BL_API_URL}/api/clientOnboarding/generateEkycOtp`;
                const response = await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                console.log("API response:", response.data);
                if (
                    response.data &&
                    response.data.data &&
                    response.data.message === "Success" &&
                    response.data.data.url
                ) {
                    setKycUrl(response.data.data.url);
                    setIFrameKyc(true);
                    setTransactionId(response.data.data.transactionId)
                    setReferenceId(response.data.data.referenceId)
                    setClientName(response.data.data.clientName || ""); // Assuming clientName is returned
                }
                // Handle response as needed
            } catch (error) {
                console.error("Error fetching initial data:", error.message);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        let timer;
        if (iFrameKyc && kycWorkflowCompleted) {
            timer = setTimeout(() => {
                pollKycStatus(); // Call your polling function here
            }, 5000); // 10 seconds
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [iFrameKyc, kycWorkflowCompleted]);

    const pollKycStatus = async () => {
        try {
            // Replace with your actual KYC status API endpoint and logic
            submitOtp();
            // Handle KYC status response as needed
        } catch (error) {
            console.error("Error polling KYC status:", error.message);
        }
    };


    /* useEffect(() => {
        if (eSignStatus === 'success') {
            const script = document.createElement('script');
            script.src = "https://signdesk.in/api/eSignWidgetUat.js";
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                const options = {
                    id: "demo user 1",
                    docket_id: docketId,
                    signer_id: signerId,
                    document_id: documentId,
                    get_id_token: function (result) {
                        alert(result);
                        console.log(result);
                    },
                    signature_status: function (result) {
                        console.log(result);
                    },
                    error_log: function (result) {
                        console.log(result);
                    }
                };
                window.esignWidgetCall(options);
            };

            return () => {
                document.body.removeChild(script);
            };
        }
    }, [eSignStatus, docketId, signerId, documentId]); */


    /*     useEffect(() => {
            if (name === null || name === "") {
                navigate("/")
            }
        })
     */
    const handleChange = (e) => {
        const value = e.target.value;
        setAadharNumber(value);
        setIsAadharValid(/^\d{12}$/.test(value));
    };

    const handleChangeOtp = (e) => {
        const value = e.target.value;
        setInputsOtp({ ...inputs, [e.target.name]: value });
        setIsOtpValid(/^\d{6}$/.test(value));
    };

    const verifyEKYC = async () => {

        setErr("");
        if (isAadharValid === false) {
            setErr("Enter valid Aadhar Number");
            return;
        }
        inputs.aadharNumber = aadharNumber;
        const url = `${config.BL_API_URL}/api/clientOnboarding/generateEkycOtp`;
        try {
            const response = await axios.post(url, inputs, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            //console.log(response.data);
            if (response.data.code === 200 && response.data.data) {
                setTransactionId(response.data.data.transactionId);
                setReferenceId(response.data.data.referenceId);
                setOtpEnabled(true);
            } else {
                setErr("Invalid response from server");
            }
        } catch (error) {
            setErr(error.message);
        }

        /* 
                const width = 400;
        const height = 400;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        const axiosConfig = {
            responseType: 'blob',
            headers: {
                Accept: 'Application/csv'
            }
        }
        axios.get(url, axiosConfig).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'allocationCalculations.csv');
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            setErr(error)
        }
        ); */
    }

    const testESignWorkflow = async () => {
        inputs.aadharNumber = aadharNumber;
        setErr("eKYC verified successfully. Redirecting for eSign");
        const eSignUrl = `${config.BL_API_URL}/api/clientOnboarding/esign/initiate`;
        const eSignResponse = await axios.post(eSignUrl, inputs, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log(eSignResponse.data);
        if (eSignResponse.data.code === 200 && eSignResponse.data.data) {
            console.log("Success... " + eSignResponse.data.data.widget_invitation_link)
            console.log(eSignResponse.data.data);

            setDocketId(eSignResponse.data.data.docket_id);
            setSignerId(eSignResponse.data.data.signer_id);
            setDocumentId(eSignResponse.data.data.document_id);
            setWidgetInvitationLink(eSignResponse.data.data.widget_invitation_link)
            setIframeUrl(true);
            openNewWindow(eSignResponse.data.data.widget_invitation_link)
            setESignStatus(true);
            localPollSignStatus();
        }
    }

    const submitOtp = async () => {
        inputsOtp.transactionId = transactionId;
        inputsOtp.referenceId = referenceId;
        inputsOtp.clientName = clientName; // Assuming clientName is needed for eKYC verification
        const url = `${config.BL_API_URL}/api/clientOnboarding/submitEkycOtp`;
        try {
            //console.log(">>>submitOTP<<< " + referenceId);
            const response = await axios.post(url, inputsOtp, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            console.log(response);
            console.log(response.data);
            if (response.data.code === 200 && response.data.message === "Success") {
                setErr("eKYC verified successfully. Redirecting for eSign");
                inputs.aadharNumber = aadharNumber;
                const eSignUrl = `${config.BL_API_URL}/api/clientOnboarding/esign/initiate`;
                const eSignResponse = await axios.post(eSignUrl, inputs, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                console.log(eSignResponse.data);
                if (eSignResponse.data.code === 200 && eSignResponse.data.data) {
                    console.log("Success... " + eSignResponse.data.data.widget_invitation_link)
                    console.log(eSignResponse.data.data);

                    setDocketId(eSignResponse.data.data.docket_id);
                    setSignerId(eSignResponse.data.data.signer_id);
                    setDocumentId(eSignResponse.data.data.document_id);
                    setWidgetInvitationLink(eSignResponse.data.data.widget_invitation_link)
                    setIframeUrl(true);
                    openNewWindow(eSignResponse.data.data.widget_invitation_link)
                    setESignStatus(true);
                } else {
                    setErr("Invalid response from server");
                }

            } else {
                setErr("Something went wrong or Name on Aadhar and agreement mismatch");
            }
        } catch (error) {
            setErr(error.message);
        }
    }

    const openNewWindow = (url) => {
        //window.ReactModal(url, '_blank', 'noopener,noreferrer');
    };

    const localPollSignStatus = async () => {
        //debugger
        console.log("Polling for eSign status... " + documentId + " polling status " + eSignStatus);
        if (documentId === null || documentId === undefined || documentId === "" || documentId === "null") {
            console.error("Document ID is null or undefined. Cannot poll signature status.");
            return
        }
        const url = `${config.BL_API_URL}/api/clientOnboarding/esign/status?docketId=${documentId}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if ((response.data === null || response.data === undefined)) {
                console.error("Polling failed with null response.");
                setErr("Polling failed with null response.");
                setESignStatus(true); // Stop polling on failure
                //enable Refresh button
                return;
            }

            if (response.data.code === 200) {
                if (response.data.message !== "eSign Not Completed") {

                    console.log("Signature completed successfully.");
                    setErr("Signature completed successfully.");
                    setESignStatus(false); // Stop polling
                    setIframeUrl(false)
                    let targetWindow = null;
                    if (window.opener && !window.opener.closed) {
                        // If opened as a popup
                        targetWindow = window.opener;
                    } else if (window.parent && window.parent !== window) {
                        // If running inside an iframe
                        targetWindow = window.parent;
                    }

                    if (targetWindow) {
                        targetWindow.postMessage(
                            JSON.stringify({
                                current_state: {
                                    success: true,
                                    result: "eSign completed successfully!",
                                    message: "success"
                                }
                            }),
                            "*" // Replace with specific origin in production
                        );
                    } else {
                        console.warn("No parent or opener window found to post message.");
                    }
                } else if (response.data.message === "eSign Not Completed") {
                    console.log("Signature is still pending. Retrying...");
                    setErr("Signature is still pending. Retrying...");
                    setTimeout(localPollSignStatus, 5000); // Retry polling after 65 seconds
                } else if (response.data.message === "eSign Completed") {
                    console.log("Signature completed successfully for both parties.");
                    setErr("Signature completed successfully for both parties.");
                    setESignStatus(false); // Stop polling
                }
            } else {
                console.error("Polling failed with status:" + response.data);
                setESignStatus(false); // Stop polling on failure
            }

        } catch (error) {
            console.error("Error polling signature status :->" + error.message);
            setTimeout(localPollSignStatus, 5000); // Retry polling on error
        }
    };

    const pollSignStatus = async () => {
        const url = "";//"https://uat.signdesk.in/api/sandbox/getSignatureStatus";
        try {
            const response = await axios.post(url, { "document_id": documentId }, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-parse-rest-api-key': '8b8ee05cdfc4a0907ccf47b3c41a41ec',
                    'x-parse-application-id': 'tradenettechnologies_esign_uat'
                }
            });
            console.log("eSign Status: " + response);
            if (response.data.status === "eSign Not Completed") {
                /*const signerInfo = response.data.signer_info.find(info => info.signer_id === signerId);
                if (signerInfo) {
                    console.log("Signature completed successfully for signer:", signerId);
                    setESignStatus(false); // Stop polling
                } else {
                    console.log("Signer ID does not match. Continuing to poll...");
                    setTimeout(pollSignStatus, 5000); // Poll every 5 seconds
                }*/
                console.error("eSign Not Completed");
                setTimeout(pollSignStatus, 5000); // Poll every 5 seconds
            } else if (response.data.status === "Success") {
                console.error("eSign Success for both parties:");
                setESignStatus(false); // Stop polling on failure
            }
            else if (response.data.status === "failed") {
                console.error("Polling failed with error code:", response.data.error_code);
                setESignStatus(false); // Stop polling on failure
            }
        } catch (error) {
            console.error("Error polling signature status:", error.message);
            setTimeout(pollSignStatus, 5000); // Retry polling on error
        }
    };

    // Trigger polling when eSignStatus is true
    useEffect(() => {
        if (eSignStatus) {
            //pollSignStatus();
            localPollSignStatus();
        }
    }, [eSignStatus]);


    return (
        <div className="w-full my-0 ">
            {/* <div className="py-14 px-1 flex justify-center items-center">
                <span className="text-gray-500 text-xl font-bold">Client eKYC</span>
            </div> */}
            <br /><br /><br />
            <div class="py-0 flex justify-center items-center">
                <div className="w-1/2 grid grid-cols-3 gap-2 justify-center items-center ">
                    

                    <div className="col-span-1 text-right">Aadhar Number</div>
                    <div className="col-span-1">
                        <input
                            type="numeric"
                            maxLength="12"
                            pattern="\d{12}"
                            onChange={handleChange}
                            name="aadharNumber"
                            id="aadharNumber"
                            className="py-2 px-1 border-black-200 shadow-sm rounded-lg  focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="Enter 12-digit Aadhar number"
                        />
                    </div>
                    <div className="col-span-1">
                        <button
                            type="button"
                            onClick={e => verifyEKYC()}
                            className="py-2 px-4 inline-flex right-0 gap-x-2 font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none "
                            disabled={!isAadharValid}
                            data-hs-overlay="#hs-basic-modal"
                        >
                            Very eKyc
                        </button>
                    </div>
                    <div className="col-span-1 text-right"></div>
                    <div className="col-span-1">
                        <input
                            type="numeric"
                            maxLength="6"
                            pattern="\d{6}"
                            onChange={handleChangeOtp}
                            name="otp"
                            id="otp"
                            className="py-2 px-1 border-black-200 shadow-sm rounded-lg focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="Enter OTP"
                            disabled={!otpEnabled}
                        />

                    </div>

                    <div className="col-span-1">
                        {/*  <button
                            type="button"
                            onClick={e => submitOtp()}
                            className="py-2 px-4 inline-flex right-0 gap-x-2  font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none "
                            disabled={!isOtpValid}
                            data-hs-overlay="#hs-basic-modal"
                        >
                            Submit OTP
                        </button> */}
                        <button
                            type="button"
                            onClick={e => testESignWorkflow()}
                            className="py-2 px-4 inline-flex right-0 gap-x-2  font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none "

                            data-hs-overlay="#hs-basic-modal"
                        >
                            Test eSignFlow
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex justify-center items-center">
                <div className="grid grid-cols-9 gap-2">
                    <div className="col-span-9 gap-2 align-left text-left ">
                        {iFrameKyc && (
                            <div className="mt-4 col-span-8">
                                {/* Add a link to open the KYC URL in a new tab */}
                                {kycUrl && (
                                    <a
                                        href={kycUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline"
                                    >
                                        Open KYC Link in New Tab
                                    </a>
                                )}
                            </div>
                        )}
                        {/* Checkbox to mark workflow completion */}
                        <div className="mt-4">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={kycWorkflowCompleted}
                                    onChange={() => setKycWorkflowCompleted(true)}
                                    disabled={kycWorkflowCompleted}
                                    style={{ marginRight: "8px" }}
                                />
                                Mark workflow as completed (start KYC polling)
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div class="flex justify-center items-center">
                <div className="grid grid-cols-9 gap-2">
                    <div className="col-span-9 gap-2 align-left text-left ">
                        {iFrameKyc && (
                            <div className="mt-4 col-span-8">
                                <iframe
                                    src={kycUrl}
                                    width="1200"
                                    height="400"

                                    title="Iframe Example"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        )}
                    </div>
                </div>
            </div> */}
            <div class="flex justify-center items-center">
                <div className="grid grid-cols-9 gap-2">
                    <div className="col-span-9 gap-2 align-left text-left ">
                        {iframeUrl && (
                            <div className="mt-4 col-span-8">
                                <iframe
                                    src={widgetInvitationLink}
                                    width="1200"
                                    height="400"

                                    title="Iframe Example"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-9 gap-2">
                <div className="col-span-9 text-center text-xs">
                    <p className="text-red-400 mt-8">
                        {err}
                    </p>
                </div>
            </div>
        </div>
    )
}
export default ClientOnboarding